import { lazy } from "react";

const SignIn = lazy(() => import("../modules/auth/sign-in"));
const SignUp = lazy(() => import("../modules/auth/sign-up"));
const VerifyEmail = lazy(() => import("../modules/auth/verify-email"));
const OTP = lazy(() => import("../modules/auth/otp"));
const ForgotPassword = lazy(() => import("../modules/auth/forgot-password"));

export const Auth = [
  {
    path: "/sign-in",
    element: <SignIn />,
  },
  {
    path: "/sign-up",
    element: <SignUp />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },
  {
    path: "/otp",
    element: <OTP />,
  },
  {
    path: "/seller-reset-password",
    element: <ForgotPassword />,
  },
];
